import script from "./BuildProgram.vue?vue&type=script&setup=true&lang=js"
export * from "./BuildProgram.vue?vue&type=script&setup=true&lang=js"

import "./BuildProgram.vue?vue&type=style&index=0&id=008283d1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-008283d1"]])

export default __exports__